// extracted by mini-css-extract-plugin
export default {"Main":"ReservationPage_Main__RsWLO"};